/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Cta_BrowseInputs */

const en_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browse Marketplace`)
};

const es_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar el mercado`)
};

const fr_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Parcourir la marketplace`)
};

const de_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marktplatz durchsuchen`)
};

const ja_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マーケットプレイスを見る`)
};

const zh_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`浏览市场`)
};

const ar_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصفح السوق`)
};

const id_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jelajahi Marketplace`)
};

const it_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora il Marketplace`)
};

const ru_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Обзор маркетплейса`)
};

const pt_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar o Marketplace`)
};

const ko_home_cta_browse = /** @type {(inputs: Home_Cta_BrowseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`마켓플레이스 둘러보기`)
};

/**
* | output |
* | --- |
* | "Browse Marketplace" |
*
* @param {Home_Cta_BrowseInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const home_cta_browse = /** @type {((inputs?: Home_Cta_BrowseInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Cta_BrowseInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_home_cta_browse(inputs)
	if (locale === "es") return es_home_cta_browse(inputs)
	if (locale === "fr") return fr_home_cta_browse(inputs)
	if (locale === "de") return de_home_cta_browse(inputs)
	if (locale === "ja") return ja_home_cta_browse(inputs)
	if (locale === "zh") return zh_home_cta_browse(inputs)
	if (locale === "ar") return ar_home_cta_browse(inputs)
	if (locale === "id") return id_home_cta_browse(inputs)
	if (locale === "it") return it_home_cta_browse(inputs)
	if (locale === "ru") return ru_home_cta_browse(inputs)
	if (locale === "pt") return pt_home_cta_browse(inputs)
	return ko_home_cta_browse(inputs)
});